/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { Container } from "react-bootstrap";

class Footer extends Component {
  render() {
    return (
      <footer className="footer px-0 px-lg-3">
        <Container fluid>
          <nav>
              <div className="bglogo">
              { (
                <>
                  {/* <img
                    className="display-image"
                    src={require("../../assets/img/icon-medicacom.png")}
                    alt="Medicacom"
                  /> */}

                </>
              ) }
            </div>
            <p className="copyright text-center float-right custom-line-height"  >
              <a href="https://www.medicacom.tn/">
                © medicacom
              </a>
            </p>
            <p className="copyright text-center float-right padding0">
              <ul className="icon-footer">
                
                <li className="margin15">
                  <a href="https://www.medicacom.tn/">
                    <i className="fas fa-link"></i>
                  </a>
                </li>
                
                <li className="margin15">
                  <a href="mailto:contact@medicacom.tn">
                    <i className="fas fa-at"></i>
                  </a>
                </li>
              </ul>
            </p>
          </nav>
        </Container>
      </footer>
    );
  }
}

export default Footer;
